import { createSelector } from 'reselect'

const nameFolderSelector = createSelector(
	[state => state.libraries],
	libraries => ({
		libraryUID: libraries.current.libraryUID,
		folderUID: libraries.name_folder_modal.folderUID,
		productUid: libraries.name_folder_modal.productUid,
		productType: libraries.name_folder_modal.productType,
		value: libraries.name_folder_modal.value,
		parentId: libraries.current.folderUID,
	})
)

export default nameFolderSelector
